import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useNotification } from '../use-notification';
import { useResolveQrMutation } from './use-qr-binding-mutations';

interface UseQrScannerNavigateOptions {
  onClose: () => void;
}

export function useQrScannerNavigate({ onClose }: UseQrScannerNavigateOptions) {
  const navigate = useNavigate();
  const { showError } = useNotification();
  const resolveMutation = useResolveQrMutation();
  const { t } = useTranslation('qrBinding');

  const handleDecode = async (qrUuid: string) => {
    try {
      const hit = await resolveMutation.mutateAsync(qrUuid);
      if (!hit) {
        showError(t('notFound'));
        return;
      }
      onClose();
      navigate(hit.redirectPath);
    } catch {
      // Mutation's onError already showed a toast; swallow to avoid unhandled rejection.
    }
  };

  return { handleDecode, isPending: resolveMutation.isPending };
}
